module.exports = __webpack_public_path__ + "img/brand-faustmann.9946e0af.png";